import { ReactElement } from "react";
import moment from "moment";

import CustomModal from "src/components/custom-modal/custom-modal";
import DeleteModal from "src/components/delete-modal/delete-modal";
import {
  isAppendix,
  requiresNewFees,
} from "../../portfolio-agreement/agreement-dates";

interface ApproveModalProps {
  isVisible: boolean;
  busy: boolean;
  type?: string | null;
  /** Values currently set on the page; submitted with the approval. */
  dateValue: string | null;
  newFees: string | null;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Plain confirmation. The date is not entered here — it is edited in the
 * details panel so the preview can be regenerated from it, and this dialog
 * only restates what will be sent.
 */
const ApproveModal: React.FC<ApproveModalProps> = ({
  isVisible,
  busy,
  type,
  dateValue,
  newFees,
  onClose,
  onConfirm,
}): ReactElement => {
  const dateName = isAppendix(type) ? "appendix date" : "portfolio open date";
  const parts: string[] = [];
  if (dateValue)
    parts.push(`${dateName} ${moment(dateValue).format("DD MMM YYYY")}`);
  if (requiresNewFees(type) && (newFees ?? "").trim())
    parts.push(`new fees ${String(newFees).trim()}`);
  const shown = parts.length
    ? `Submitted with it: ${parts.join(" and ")}.`
    : `No ${dateName} is set, so none is submitted.`;

  return (
    <CustomModal
      isVisible={isVisible}
      centered
      width={450}
      showClose={false}
      onClose={onClose}
      className="delete-modal"
    >
      <DeleteModal
        icon="/images/approve-icon.svg"
        text="Approve agreement"
        subText={`The final document is generated, delivered to Prospero and emailed to the client. ${shown}`}
        confirmText={busy ? "Approving…" : "Approve"}
        confirmDisabled={busy}
        onCancel={onClose}
        onConfirm={onConfirm}
      />
    </CustomModal>
  );
};

export default ApproveModal;
